import { ONEETHOS_SOLAR_FAQ_LINK } from '@oneethos/shared'
import AgreementCheckbox from '../../components/agreement-checkbox'
import { SubformProps } from '../'

const ConsumerResourceAgreement = ({ formData, update }: Partial<SubformProps>) => {
  return (
    <AgreementCheckbox
      formData={formData}
      update={update}
      name="attestConsumerResourceUnderstanding"
    >
      I understand these resources are provided to help me make an informed decision
      regarding my solar project and related lending options
    </AgreementCheckbox>
  )
}

export const SolarConsumerEducationLink = () => {
  return (
    <div>
      <p className='text-dark'><b> Learn more by reviewing OneEthos' Solar Consumer Education Resources:</b></p>
      <p className='mb-0'>
        <a href={ONEETHOS_SOLAR_FAQ_LINK} target="_blank" rel="noopener noreferrer">Visit the OneEthos Solar FAQs</a>
      </p>
    </div>
  )
}

const ResidentialSolarResources = () => {
  return (
    <div className='mt-2'>
      <p className='text-dark'><b>Before You Decide to Go Solar, Take a Few Minutes to Learn More</b></p>
      <p>
        Making an informed decision is one of the most important steps in the solar purchasing process.
        To help customers better understand their options, our technology partner, OneEthos, provides
        educational resources designed to explain key aspects of solar energy, financing, and project
        installation in a clear, objective, and easy-to-understand manner.
      </p>
      <p>
        These materials are intended to help you evaluate proposals, compare alternatives, understand your
        rights and responsibilities, and ask the right questions before entering into any agreement.
        We strongly encourage you to review this information carefully and ensure you fully understand
        the terms, costs, benefits, risks, and obligations associated with a solar purchase or financing
        arrangement before signing a contract with a solar installer or proceeding with financing through
        a financial institution.
      </p>
      <p className='text-dark'><b>Topics covered include:</b></p>
      <ul>
        <li>Questions to ask before signing a solar contract</li>
        <li>Understanding solar financing and payment obligations</li>
        <li>Comparing ownership, lease, and financing options</li>
        <li>Reviewing warranties, production estimates, and contractor commitments</li>
        <li>Consumer rights and protections</li>
      </ul>
      <p>
        These materials are provided solely for educational purposes and do not constitute a loan offer,
        credit approval, financial advice, recommendation, or endorsement of any solar contractor, product,
        equipment provider, or financing option. Your decision to purchase solar or obtain financing should be
        based on your individual circumstances and an independent evaluation of the available options.
      </p>
    </div>
  )
}

export const ConsumerResourceLinks = ({ formData, update }: Partial<SubformProps>) => {

  return (
    <>
      <div className='bg-light p-3 rounded-4 my-3'>
        <div className='d-flex justify-content-between  gap-3'>
          <div>
            <ResidentialSolarResources />
            <SolarConsumerEducationLink />
          </div>
          <img
            src="/images/pb-eo-logo.png"
            alt="Powered by OneEthos"
            className='flex-shrink-0 align-self-end'
            style={{ width: 150, height: 'auto' }}
          />
        </div>
      </div>
      <ConsumerResourceAgreement formData={formData} update={update} />
    </>
  )
}
